import publicHttpClient from 'api/publicHttpClient';
import { EtaForm } from 'router/pages/EtaForum/types';

function submit(data: EtaForm) {
  return publicHttpClient.post('eta-forms', data);
}

export default {
  submit,
};
